import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 存储token
    Authorization: localStorage.getItem('Authorization') ? localStorage.getItem('Authorization') : ''
  },
  mutations: {
    // 修改token，并将token存入sessionStorage
    changeLogin (state,user) {
      state.Authorization = user.Authorization;
      // console.log("store/stroe.js---到这里了!");
      localStorage.setItem('Authorization', user.Authorization);
    },
    changeLoginReal (state,user) { //当Token是真的时候，才会存
      state.Authorization = user.Authorization;
      sessionStorage.setItem('RealToken', user.Authorization);
    }
  },
  actions: {

  }
})
